"use strict";

exports.__esModule = true;
exports.SECONDS = exports.MINUTES = exports.HOURS = void 0;
var HOURS = 'hours';
exports.HOURS = HOURS;
var MINUTES = 'minutes';
exports.MINUTES = MINUTES;
var SECONDS = 'seconds';
exports.SECONDS = SECONDS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/constants/clock-types.js
// module id = 100
// module chunks = 0